import React, {useState} from 'react';
import {Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {ErrorToast, SuccessToast} from "../../../shared/toasters/toasters";
import {INewsAutoInformation} from "../interface";
import {AdminNewsAutoInformationService} from "../service";
import CreateForm from "./CreateForm";

const CreateNewsAutoInformation = () => {
    const {t} = useTranslation();
    const navigate = useNavigate()
    const [state, setState] = useState<INewsAutoInformation | null>(null);
    const submitHandler = () => {
        AdminNewsAutoInformationService.create(state as INewsAutoInformation)
            .then(() => {
                SuccessToast(t(`news_auto_information.successfully_created`));
                navigate('/admin/news-auto-information');
                setState(null);
            })
            .catch((error) => ErrorToast(error));
    };
    return (
        <div className="col-12">
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    submitHandler();
                }}
            >
                <CreateForm state={state} setState={setState}/>
            </Form>
        </div>
    );
};

export default CreateNewsAutoInformation;